export const LOGIN_USER_DATA = "LOGIN_USER_DATA";
export const LOGIN_SUCCESS_DATA = "LOGIN_SUCCESS_DATA";
export const LOGIN_DATA_RESET = "LOGIN_DATA_RESET";


export const LOGOUT_USER_CLEAR = "LOGOUT_USER_CLEAR";
export const LOGOUT_USER_SUCCESS_CLEAR = "LOGOUT_USER_SUCCESS_CLEAR";

export const LOGIN_ERROR = "LOGIN_ERROR";